import { clsx } from 'clsx';
import { Link } from '@client/router/compat';

import { Checkbox } from '@design-system/components/checkbox/checkbox';

import type { AutomationDetailsViewModel } from '../../view-model/AutomationDetails.viewModel';
import { useMonthlyToAnnualConfigViewModel } from '../../view-model/MonthlyToAnnualConfig.viewModel';
import * as styles from '../Automations.view.css';

/** Figma screen 04 minus the discount input: the saving is read from the
 *  creator's prices (GRW-571), so the box is read-only. */
export const MonthlyToAnnualConfigView = ({
  creatorId,
  details,
}: {
  creatorId: number;
  details: AutomationDetailsViewModel;
}) => {
  const vm = useMonthlyToAnnualConfigViewModel(details);

  return (
    <div className={styles.configForm} data-testid="m2a-config">
      <div className={styles.configCard}>
        <div className={styles.configCardHead}>
          <span className={styles.configCardTitle}>Your annual saving</span>
        </div>
        <span className={styles.configCardHint}>
          The emails promise a saving, so we take it from your current monthly
          and annual prices. Members keep the same access either way.
        </span>
        <div
          className={clsx(
            styles.savingBox,
            vm.summary.kind === 'saving'
              ? styles.savingBoxOk
              : styles.savingBoxWarn,
          )}
          data-testid={`m2a-summary-${vm.summary.kind}`}
        >
          {vm.summary.text}
          {vm.summary.kind === 'unavailable' ? (
            <>
              {' '}
              <Link
                to={`/subscriptions/${creatorId}`}
                className={styles.viewInsights}
              >
                Set up annual pricing
              </Link>
            </>
          ) : null}
        </div>
      </div>

      <div className={styles.configCard}>
        <div className={styles.configCardHead}>
          <span className={styles.configCardTitle}>Push notifications</span>
          <span className={styles.optionalTag}>Optional</span>
        </div>
        <span className={styles.configCardHint}>
          Two pushes back up the emails. They only reach members who allowed
          notifications.
        </span>
        <Checkbox
          label="Include the 2 push notifications"
          checked={vm.includePushes}
          onChange={vm.setIncludePushes}
          testId="m2a-include-pushes"
        />
      </div>
    </div>
  );
};
